import React from "react";
import { Plus, MessageSquare, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useGuruThreads, type GuruThread } from "@/hooks/useGuruChat";
import { cn } from "@/lib/utils";

interface ThreadListProps {
  activeId: string | null;
  onSelect: (id: string) => void;
  onCreate: () => void;
  threads: GuruThread[];
  onDelete: (id: string) => void | Promise<void>;
}

const ThreadList: React.FC<ThreadListProps> = ({ activeId, onSelect, onCreate, threads, onDelete }) => {
  return (
    <div className="h-full flex flex-col bg-card/40 border-r border-border">
      <div className="p-3 border-b border-border">
        <Button onClick={onCreate} className="w-full bg-gradient-to-r from-gold-600 to-gold-500 text-card hover:from-gold-700 hover:to-gold-600">
          <Plus className="h-4 w-4 mr-1" /> Nova conversa
        </Button>
      </div>
      <div className="flex-1 overflow-y-auto p-2 space-y-1">
        {threads.length === 0 && (
          <p className="text-center text-xs text-muted-foreground p-4">Nenhuma conversa ainda.</p>
        )}
        {threads.map((t) => (
          <div
            key={t.id}
            className={cn(
              "group flex items-center gap-2 rounded-md px-2 py-2 cursor-pointer hover:bg-accent transition-colors",
              activeId === t.id && "bg-accent border border-gold-500/30"
            )}
            onClick={() => onSelect(t.id)}
          >
            <MessageSquare className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
            <span className="flex-1 text-sm truncate text-foreground">{t.title}</span>
            <button
              className="opacity-0 group-hover:opacity-100 p-1 rounded hover:bg-destructive/10 text-destructive"
              onClick={(e) => { e.stopPropagation(); if (confirm("Excluir esta conversa?")) void onDelete(t.id); }}
              aria-label="Excluir conversa"
            >
              <Trash2 className="h-3.5 w-3.5" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ThreadList;
